import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BaseDialog from "../../components/BaseDialog";
import { Box, Button } from "@mui/material";
import TextField from "../../components/TextField";
import { calculateValueFromEvent } from "../../components/Utils";
import { hasErrors, required, validate, validateAll } from "../../components/Validators";
import LoadingDialog from "../../components/LoadingDialog";
import DialogOkCancel from "../../components/DialogOkCancel";
import useApi from "../../api";
import { isUndefined } from "lodash";
import { AppContext } from "../../App";
import { cerrarEstanciaPension } from "../../api/controlador";
import { RENDER_TAGS } from "../tags/ConsultaTagPanel";

const fieldsValidators = {
    'motivo': [required],
}

const initialData = {
    motivo: '',
}

const defaultErrors = {
    motivo: '',
}

const CerrarEstanciaPensionado = ({ ...props }) => {

    const appContext = useContext(AppContext);
    let { state } = useLocation();
    const navigate = useNavigate();

    // const { comercioId } = useParams();
    const { tags, registros } = state;

    const { notificar } = appContext;

    const [data, setData] = useState(initialData);
    const [errors, setErrors] = useState(defaultErrors);
    const [dirty, setDirty] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({ open: false, msg: null });
    const [open, setOpen] = useState(true);

    const [{ data: cerrarEstanciaPensionData, loading: loadingRegistrarIncidencia }, cerrarEstanciaPensionApi] = useApi();


    //Agregar cliente
    useEffect(() => {
        if (!isUndefined(cerrarEstanciaPensionData)) {
            notificar("Estancia de pensión cerrada");
            setOpen(false);
            if (props.onShouldUpdate) { //Avisamos por si quieren actualizar algo...
                props.onShouldUpdate();
            }
        }
    }, [cerrarEstanciaPensionData])

    useEffect(() => {
        if (dirty === true) {
            const errors = validateAll(data, fieldsValidators);
            const isErrors = hasErrors(errors);
            setIsValid(!isErrors);
        }
    }, [data])

    const handleChangeValue = name => event => {
        const value = calculateValueFromEvent(event);
        const error = validate(value, fieldsValidators[name]);

        setData({
            ...data,
            [name]: value
        });
        setErrors({
            ...errors,
            [name]: error
        })
        setDirty(true);
    }

    const handleOnBlur = name => event => {
        const value = event.target.value;
        const error = validate(value, fieldsValidators[name]);
        setErrors({
            ...errors,
            [name]: error
        })
    }

    const handleGuardar = () => {
        if (isValid) {
            setConfirmDialog({
                open: true,
                msg: <>
                    ¿Confirmas registrar la incidencia?<br /><br />
                    Esta acción no se puede deshacer.
                </>,
                onOk: handleConfirmaRegistrar,
                onCancel: handleCancelRegistrar
            });
        }
    }

    const handleCancelRegistrar = () => {
        setConfirmDialog({ open: false, msg: null })
    }

    const handleConfirmaRegistrar = () => {
        setConfirmDialog({ open: false, msg: null })
        const body = {
            ...data,
            estancias: registros
        }
        cerrarEstanciaPensionApi(cerrarEstanciaPension(body));
    }

    const handleExited = () => {
        navigate(-1);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const title = 'Cerrar estancia pensionado';

    return (
        <>
            <BaseDialog open={open} onExited={handleExited} title={title} onClose={handleClose} fullWidth
                actions={
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button onClick={handleClose} color="primary">Cerrar</Button>
                        <Button onClick={handleGuardar} color="primary" variant="contained" disabled={!isValid}>Guardar</Button>
                    </Box>
                }>
                <Box>
                    <>
                        Cerrar estancia de pensión para {RENDER_TAGS(tags)}.
                    </>
                    <TextField
                        fullWidth
                        required
                        label="Motivo"
                        field="motivo"
                        value={data.motivo}
                        onChange={handleChangeValue('motivo')}
                        onBlur={handleOnBlur('motivo')}
                        errors={errors}
                    />
                </Box>
            </BaseDialog>
            <DialogOkCancel {...confirmDialog} />
            <LoadingDialog open={loadingRegistrarIncidencia} />
        </>
    );
}

export default CerrarEstanciaPensionado;